import { FC, PropsWithChildren, ReactNode } from 'react';
import { styled } from 'styled-components';

import { CloseButton } from './close-button';

type VideoBrowserTemplateProps = Readonly<{
  leftPane: ReactNode;
  onClose?: () => void;
}>;

export const VideoBrowserTemplate: FC<PropsWithChildren<VideoBrowserTemplateProps>> = ({
  onClose,
  leftPane,
  children,
}) => (
  <VideoBrowserContainer className="d-block d-lg-flex flex-row border border-light border-opacity-40 rounded-1 shadow-max m-0 overflow-hidden">
    <div className="side-panel d-flex d-lg-block bg-lvl1 h-100 flex-grow-0 flex-shrink-0">
      <h1 className="modal-title p-3 p-lg-4 lh-1">Videos</h1>
      <div className="overflow-auto">{leftPane}</div>
    </div>
    <div className="modal-body d-flex flex-column p-0 bg-black overflow-hidden">
      {onClose && <CloseButton onClick={onClose} />}
      {children}
    </div>
  </VideoBrowserContainer>
);

const VideoBrowserContainer = styled.div`
  & .modal-content {
    min-height: 100vh !important;
  }
  & .modal-body {
    min-height: 100vh !important;
  }
  & .modal-title {
    font-size: 18px;
  }
  .card-title {
    font-size: 24px;
  }
  .bg-blur {
    backdrop-filter: blur(24px);
  }
  .bg-blur-gradient {
    backdrop-filter: blur(32px);
    mix-blend-mode: luminosity;
    mask-image: linear-gradient(to top, rgba(0, 0, 0, 1) 1%, rgba(0, 0, 0, 0) 100%);
  }
  .card-caption {
    mix-blend-mode: luminosity;
    background: linear-gradient(to top, #000, rgba(0, 0, 0, 0.3) 45%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 100%);
  }
  .prev.btn:hover {
    color: white;
    background-color: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(16px);
    transition: 0.3s;
  }
  .next.btn:hover {
    color: white;
    background-color: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(16px);
    transition: 0.3s;
  }
  .video-thumbnail {
    min-height: auto;
    background: #303333;
  }

  @media (min-width: 720px) {
    & .modal-content {
      min-height: auto !important;
    }
    & .modal-body {
      min-height: auto !important;
    }
    .card-title {
      font-size: 32px;
    }
    .side-panel {
      width: 250px;
    }
  }

  @media (min-width: 1024px) {
    .modal-fullscreen {
      display: none;
    }
    & .modal-title {
      font-size: 20px;
    }
    .slider-nav,
    .track {
      min-height: 152px !important;
    }
    .slider-nav .slick-track {
      padding-left: 28px;
      padding-top: 24px;
      padding-bottom: 24px;
      min-height: 152px !important;
      width: max-content !important;
    }
    .video-thumbnail {
      min-height: 102px !important;
    }
    .side-panel {
      width: 300px;
    }
  }

  @media (min-width: 1440px) {
    & .modal-title {
      font-size: 24px;
    }
    .card-title {
      font-size: 40px;
    }
  }
`;
